// Utility functions to generate random data for reports
// Pakistani business names
export const pakistaniBusinessNames = [
  'Habib Bank Limited',
  'United Bank Limited',
  'MCB Bank Limited',
  'Bank Alfalah',
  'Meezan Bank',
  'Allied Bank Limited',
  'National Bank of Pakistan',
  'JS Bank',
  'Askari Bank',
  'Faysal Bank',
  'Soneri Bank',
  'Summit Bank',
  'Telenor Microfinance Bank',
  'HBL Microfinance Bank',
  'Mobilink Microfinance Bank',
  'U Microfinance Bank',
  'Khushhali Microfinance Bank',
  'First Microfinance Bank',
  'NRSP Microfinance Bank',
  'FINCA Microfinance Bank',
  'Apna Microfinance Bank',
  'Advans Pakistan Microfinance Bank',
  'Pak Oman Microfinance Bank',
  'Sindh Microfinance Bank',
  'Pak-Qatar Family Takaful',
  'EFU Life Assurance',
  'Jubilee Life Insurance',
  'State Life Insurance Corporation',
  'Adamjee Insurance',
  'TPL Insurance',
  'UBL Insurers',
  'Allianz EFU Health Insurance',
  'Dawood Family Takaful',
  'Takaful Pakistan Limited',
  'IGI Insurance',
  'Askari General Insurance',
  'Century Insurance',
  'Habib Insurance',
  'New Jubilee Insurance',
  'Security General Insurance',
  'United Insurance',
  'Shaheen Insurance',
  'Reliance Insurance',
  'Premier Insurance',
  'Alpha Insurance',
  'Asia Insurance',
  'East West Insurance',
  'Crescent Star Insurance',
  'The United Insurance',
]
// Pakistani cities
export const pakistaniCities = [
  'Karachi',
  'Lahore',
  'Islamabad',
  'Rawalpindi',
  'Faisalabad',
  'Multan',
  'Peshawar',
  'Quetta',
  'Sialkot',
  'Gujranwala',
  'Hyderabad',
  'Abbottabad',
  'Bahawalpur',
  'Sargodha',
  'Sukkur',
  'Larkana',
  'Sheikhupura',
  'Jhang',
  'Rahim Yar Khan',
  'Gujrat',
]
// MCC Codes with descriptions
const mccCodes = [
  { code: '5411', description: 'Grocery Stores & Supermarkets' },
  { code: '5812', description: 'Restaurants' },
  { code: '5912', description: 'Drug Stores & Pharmacies' },
  { code: '5541', description: 'Service Stations' },
  { code: '5311', description: 'Department Stores' },
  { code: '5999', description: 'Miscellaneous Retail Stores' },
  { code: '4722', description: 'Travel Agencies & Tour Operators' },
  { code: '7011', description: 'Hotels & Motels' },
  { code: '4121', description: 'Taxicabs & Limousines' },
  { code: '5814', description: 'Fast Food Restaurants' },
  { code: '5651', description: 'Family Clothing Stores' },
  { code: '5499', description: 'Miscellaneous Food Stores' },
  { code: '5977', description: 'Cosmetic Stores' },
  { code: '5944', description: 'Jewelry Stores' },
  { code: '5732', description: 'Electronics Stores' },
]
// Generic business contact titles
const genericContactTitles = [
  'Customer Support',
  'Account Manager',
  'Finance Department',
  'Operations Manager',
  'Sales Representative',
  'Branch Manager',
  'Relationship Manager',
  'IT Support',
  'Customer Service',
  'Treasury Department',
  'Corporate Banking',
  'Merchant Support',
  'Payment Solutions',
  'Business Development',
  'Client Relations',
]
// Generic email prefixes
const genericEmailPrefixes = [
  'info',
  'support',
  'contact',
  'sales',
  'help',
  'customercare',
  'service',
  'corporate',
  'merchants',
  'payments',
  'business',
  'operations',
  'accounts',
  'finance',
  'inquiries',
]
// Pakistani names
const pakistaniNames = [
  'Ali Khan',
  'Fatima Ahmed',
  'Muhammad Qasim',
  'Ayesha Malik',
  'Ahmed Hassan',
  'Zainab Iqbal',
  'Omar Farooq',
  'Sana Javed',
  'Bilal Siddiqui',
  'Mehwish Hayat',
  'Imran Shah',
  'Hina Altaf',
  'Kamran Akmal',
  'Saima Rashid',
  'Tariq Jameel',
  'Farah Khan',
  'Asad Ali',
  'Nadia Hussain',
  'Zubair Ahmed',
  'Rabia Anum',
  'Fawad Khan',
  'Sanam Baloch',
  'Shahid Afridi',
  'Saba Qamar',
  'Wasim Akram',
  'Mahira Khan',
  'Shoaib Malik',
  'Mawra Hocane',
  'Babar Azam',
  'Sajal Aly',
]
// Generate random merchant registration data
export const generateMerchantRegistrationData = (
  aggregators: string[],
  fromDate: Date,
  toDate: Date,
  status: string,
) => {
  const data = []
  const statuses =
    status === 'All'
      ? ['Pending', 'In Process', 'Completed', 'Rejected']
      : [status]
  // Generate between 50-100 records
  const count = Math.floor(Math.random() * 50) + 50
  for (let i = 0; i < count; i++) {
    const randomBusinessName =
      pakistaniBusinessNames[
        Math.floor(Math.random() * pakistaniBusinessNames.length)
      ]
    const randomContactTitle =
      genericContactTitles[
        Math.floor(Math.random() * genericContactTitles.length)
      ]
    const randomEmailPrefix =
      genericEmailPrefixes[
        Math.floor(Math.random() * genericEmailPrefixes.length)
      ]
    const randomCity =
      pakistaniCities[Math.floor(Math.random() * pakistaniCities.length)]
    const randomAggregator =
      aggregators[Math.floor(Math.random() * aggregators.length)]
    const randomStatus = statuses[Math.floor(Math.random() * statuses.length)]
    const randomDate = new Date(
      fromDate.getTime() +
        Math.random() * (toDate.getTime() - fromDate.getTime()),
    )
    // Generate random last transaction date (between registration date and now)
    const lastTxnDate = new Date(
      randomDate.getTime() +
        Math.random() * (new Date().getTime() - randomDate.getTime()),
    )
    // Generate random MDR (not more than 2.4%)
    const mdr = (Math.random() * 2.4).toFixed(2)
    // Generate random MCC
    const randomMcc = mccCodes[Math.floor(Math.random() * mccCodes.length)]
    // Generate random settlement mode
    const settlementMode = Math.random() > 0.5 ? 'Instant' : 'Deferred'
    const businessNameWords = randomBusinessName.split(' ')
    const shortName =
      businessNameWords.length > 1
        ? businessNameWords[0].charAt(0) + businessNameWords[1].charAt(0)
        : businessNameWords[0].substring(0, 2)
    // Format business name for email domain (lowercase, no spaces)
    const emailDomain = randomBusinessName.toLowerCase().replace(/\s+/g, '')
    data.push({
      id: `MER${shortName}${Math.floor(Math.random() * 1000000)}`,
      merchantName: randomBusinessName,
      businessName: randomBusinessName,
      aggregator: randomAggregator,
      registrationDate: randomDate.toISOString().split('T')[0],
      status: randomStatus,
      contactPerson: randomContactTitle,
      contactEmail: `${randomEmailPrefix}@${emailDomain}.com.pk`,
      contactPhone: `+92${Math.floor(Math.random() * 1000000000)}`,
      merchantMcc: `${randomMcc.code} - ${randomMcc.description}`,
      merchantCity: randomCity,
      merchantCountry: 'Pakistan',
      merchantMdr: `${mdr}%`,
      merchantSettlementMode: settlementMode,
      lastTransactionDate: lastTxnDate.toISOString().split('T')[0],
    })
  }
  return data
}
// Generate random merchant transaction data
export const generateMerchantTransactionData = (
  aggregators: string[],
  fromDate: Date,
  toDate: Date,
  status: string,
) => {
  const data = []
  const statuses =
    status === 'All'
      ? ['Pending', 'Completed', 'Failed', 'Settled', 'Un-Settled']
      : [status]
  // Generate between 50-100 records
  const count = Math.floor(Math.random() * 50) + 50
  for (let i = 0; i < count; i++) {
    const randomBusinessName =
      pakistaniBusinessNames[
        Math.floor(Math.random() * pakistaniBusinessNames.length)
      ]
    const randomAggregator =
      aggregators[Math.floor(Math.random() * aggregators.length)]
    const randomStatus = statuses[Math.floor(Math.random() * statuses.length)]
    const randomDate = new Date(
      fromDate.getTime() +
        Math.random() * (toDate.getTime() - fromDate.getTime()),
    )
    const amount = Math.floor(Math.random() * 1000000) / 100
    const businessNameWords = randomBusinessName.split(' ')
    const shortName =
      businessNameWords.length > 1
        ? businessNameWords[0].charAt(0) + businessNameWords[1].charAt(0)
        : businessNameWords[0].substring(0, 2)
    data.push({
      id: `TXN${Math.floor(Math.random() * 1000000)}`,
      merchantId: `MER${shortName}${Math.floor(Math.random() * 100000)}`,
      merchantName: randomBusinessName,
      aggregator: randomAggregator,
      transactionDate: randomDate.toISOString().split('T')[0],
      transactionTime: `${Math.floor(Math.random() * 24)}:${Math.floor(Math.random() * 60)}:${Math.floor(Math.random() * 60)}`,
      amount: amount.toFixed(2),
      currency: 'PKR',
      status: randomStatus,
      cardType: ['Visa', 'Mastercard', 'American Express', 'UnionPay', 'JCB'][
        Math.floor(Math.random() * 5)
      ],
      cardNumber: `**** **** **** ${Math.floor(1000 + Math.random() * 9000)}`,
    })
  }
  return data
}
// Generate random merchant transaction summary data
export const generateMerchantTransactionSummaryData = (
  aggregators: string[],
  fromDate: Date,
  toDate: Date,
  status: string,
) => {
  const data = []
  const statuses =
    status === 'All'
      ? ['Pending', 'Completed', 'Failed', 'Settled', 'Un-Settled']
      : [status]
  // Generate between 20-50 records
  const count = Math.floor(Math.random() * 30) + 20
  for (let i = 0; i < count; i++) {
    const randomBusinessName =
      pakistaniBusinessNames[
        Math.floor(Math.random() * pakistaniBusinessNames.length)
      ]
    const randomAggregator =
      aggregators[Math.floor(Math.random() * aggregators.length)]
    const completedCount = Math.floor(Math.random() * 1000)
    const failedCount = Math.floor(Math.random() * 200)
    const pendingCount = Math.floor(Math.random() * 100)
    const totalAmount = Math.floor(Math.random() * 10000000) / 100
    const businessNameWords = randomBusinessName.split(' ')
    const shortName =
      businessNameWords.length > 1
        ? businessNameWords[0].charAt(0) + businessNameWords[1].charAt(0)
        : businessNameWords[0].substring(0, 2)
    data.push({
      merchantId: `MER${shortName}${Math.floor(Math.random() * 100000)}`,
      merchantName: randomBusinessName,
      aggregator: randomAggregator,
      period: `${fromDate.toISOString().split('T')[0]} to ${toDate.toISOString().split('T')[0]}`,
      totalTransactions: completedCount + failedCount + pendingCount,
      completedTransactions: completedCount,
      failedTransactions: failedCount,
      pendingTransactions: pendingCount,
      totalAmount: totalAmount.toFixed(2),
      currency: 'PKR',
      successRate: `${Math.floor((completedCount / (completedCount + failedCount + pendingCount)) * 100)}%`,
    })
  }
  return data
}
